import React from 'react';
import PageBanner from "@/components/pageBanner";

const SupportOnline = () => {
    return (
        <>
            <PageBanner title="Online Support Guides" slug="support-online"/>
            <section className="generic-container py-14">

                <ul className={"list-disc pl-5"}>
                    <li>
                        <p className="font-bold">Installing TeamViewer for Troubleshooting AI Assistant Issues</p>
                        <p>
                            For users experiencing unique issues with the AI Assistant, we provide remote support via
                            TeamViewer. This guide will walk you through the installation process to help diagnose and
                            resolve potential problems.
                        </p>
                    </li>
                    <li className="mt-4">
                        <p className="font-bold">How to Install TeamViewer</p>
                        <p>
                            Follow these steps to set up TeamViewer for remote assistance:
                        </p>
                    </li>
                    <ol className={"mt-2"}>
                        <li>1. Go to <a href="https://www.teamviewer.com/" target="_blank" className="text-lt-blue">TeamViewer’s
                            official website</a>.
                        </li>
                        <li>2. Click on Download for Windows/Mac and run the installer.</li>
                        <li>3. Select Default installation and follow the on-screen instructions.</li>
                        <li>4. Once installed, launch TeamViewer and locate your ID and Password.</li>
                        <li>5. Share these credentials with our support team so they can remotely assist you.</li>
                    </ol>
                    <li className="mt-4">
                        <p className="font-bold">Getting Remote Assistance</p>
                        <p>
                            Once you have TeamViewer installed, contact our support team and provide your ID and Password. Our specialists will securely connect to your device and help resolve any issues with the AI Assistant.
                        </p>
                    </li>
                </ul>

            </section>
        </>
    )
}

export default SupportOnline;